import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomValidators } from 'src/app/condivisa/custom-validators';
import { EbwModalService } from 'src/app/library/ebw-modals-angular/ebw-modal.service';
import { EBWModalResult } from 'src/app/library/ebw-modals-angular/model/ebw-modal.model';
import { AnalysisDataAccessService } from 'src/app/servizi/analysis/analysis-data-access.service';

@Component({
  selector: 'app-analysis-modal-edit',
  templateUrl: './analysis-modal-edit.component.html',
  styleUrls: ['./analysis-modal-edit.component.scss']
})
export class AnalysisModalEditComponent implements OnInit {
  public ids;
  public editForm: FormGroup;

  public fieldChoiceDropdown = [
    {
      value: 'nome_sito',
      label: 'Nome Sito'
    },
    {
      value: 'piano_lavori',
      label: 'Piano Lavori'
    },
    {
      value: 'anno_piano_lavori',
      label: 'Anno Piano Lavori'
    },
    {
      value: 'sr',
      label: 'SR'
    },
    {
      value: 'colore',
      label: 'Colore'
    }
  ]

  public activeField = 'nome_sito';
  public cpColor: string = '#ffffff';
  public cpPosition = "bottom";
  public edited = false;

  modalRef: NgbModalRef = null;

  constructor(
    private _analysisDataAccessService: AnalysisDataAccessService,
    private _ebwModalService: EbwModalService,
    private _fb: FormBuilder,
    public modal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this._initForm();
  }

  public onActiveFieldChange(event) {
    this.editForm.reset();
  }

  public onSubmit() {

    let content;
    let title;
    
    if(this.ids.length > 1){
      title ="Modifica Analisi Massiva";
      content = "L'operazione comporterà la modifica massiva delle analisi selezionate. Continuare?";
    } else {
      title ="Modifica Analisi";
      content = "L'operazione comporterà la modifica dell'analisi selezionata. Continuare?";
    }

    this._ebwModalService.openConfirmModal({
      title: title,
      content: content
    }).result.then(res => {
      if (res == EBWModalResult.Confirm) {
        this._editanalyses();
      }
    })
  }

  public onChangeColor(color: string): void {
    this.editForm.get("colore").setValue(color);
    this.cpColor = color;
  }

  private _initForm() {
    this.editForm = this._fb.group({
      piano_lavori: new FormControl(null),
      anno_piano_lavori: new FormControl(null, Validators.compose([CustomValidators.onlyNumbers()])),
      sr: new FormControl(null),
      colore: new FormControl("#fff"),
      nome_sito: new FormControl(null)
    });
  }

  private _editanalyses() {
    this._analysisDataAccessService.updateAnalyses({ ids: this.ids, data: { [this.activeField]: this.editForm.value[this.activeField] } }).subscribe({
      next: (res) => {
        if (!res || res.error !== 0) {
          this._ebwModalService.openErrorModal({
            title: "Errore",
            content: "Errore modifica dati: " + res.errorDescription
          });
        }
        this._ebwModalService.openSuccessModal({
          title: "Successo",
          content: "Analisi modificate con successo"
        });

        this.edited = true;
      
      },
      error: (error) => {
        this._ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore modifica dati"
        });
      }
    });
  }

}
